import { Button, Stack, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';

interface DeleteItemDialogProps {
  onClose: () => void;
  onSubmit: () => void;
  loading?: boolean;
}

export const DeleteItemDialog = ({
  onClose,
  onSubmit,
  loading = false,
}: DeleteItemDialogProps) => {
  return (
    <BaseDialog
      onClose={onClose}
      open
      fullWidth
      actionsComponent={
        <Stack spacing={2} direction="row" justifyContent="flex-end">
          <Button onClick={onSubmit} color="error" loading={loading}>
            Excluir
          </Button>
          <Button variant="contained" onClick={onClose}>
            Cancelar
          </Button>
        </Stack>
      }
      icon={<Icon name="siren-rounded" />}
      title="Tem certeza que deseja excluir?"
    >
      <Typography>Essa ação é permanente e não poderá ser desfeita.</Typography>
    </BaseDialog>
  );
};
